/* global document, window */

import { MainListings } from './components/MainListings'


window.webfxPropertiesManager = window.webfxPropertiesManager || {}


const execute = () => {
	const node = document.querySelector( '.js-main-listings' )

	if( node ) {
		window.webfxPropertiesManager.mainListings = new MainListings( node )
		window.webfxPropertiesManager.mainListings.init()
	}
}


if( 'complete' === document.readyState ) {
	execute()
} else {
	window.addEventListener('load', execute)
}